<template>
  <div class="container">
    <my-carousel></my-carousel>
    <p>{{ $t('general.Save') }}</p>
  </div>
</template>

<script>
import MyCarousel from "@/components/MyCarousel";
export default {
name: "Pruebas",
  components: {MyCarousel}
}
</script>

<style scoped>

</style>
